/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Edit_Logistics_Details_TitleInputs */

const en_orders_edit_logistics_details_title = /** @type {(inputs: Orders_Edit_Logistics_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Logistics Details`)
};

const es_orders_edit_logistics_details_title = /** @type {(inputs: Orders_Edit_Logistics_Details_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar detalles de logistica`)
};

/**
* | output |
* | --- |
* | "Edit Logistics Details" |
*
* @param {Orders_Edit_Logistics_Details_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_edit_logistics_details_title = /** @type {((inputs?: Orders_Edit_Logistics_Details_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Edit_Logistics_Details_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_edit_logistics_details_title(inputs)
	return es_orders_edit_logistics_details_title(inputs)
});